import React from "react"
import classnames from "classnames"
import styles from "./OffersFilters.less"
import { fromLinkInputs } from "AtomicUtils/formHandler"
import componentParser from "AtomicUtils/componentParser"
import { H5, Space, CheckBoxGroup, InputRange, CrossIcon, Button } from "AtomicComponents"

class OffersFilters extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        nameplate: {
        },
        price: {
        },
        transmission: {
        },
        drivetrain: {
        }
      }
    }
  }

  componentDidUpdate() {
    const { onChange = () => { } } = this.props
    const { form } = this.state
    let filters = {}

    Object.keys(form).map(filter => {
      filters[filter] = form[filter].value ? form[filter].value : []
    })

    onChange(filters)
  }

  render() {
    const { nameplateFilters, transmissionFilter, priceFilter, drivetrainFilters, open = false, onClose = () => { } } = this.props

    return (
      <div
        className={classnames({
          [styles.OffersFilters]: true,
          [styles.OffersFiltersTablet]: open
        })}>
          <div
            onClick={onClose}
            className={classnames({
              [styles.OffersFiltersTabletClose]: true
            })}>
            <CrossIcon />
          </div>
          <H5 withDetails>REFINE SEARCH</H5>
          <Space />
          {
            nameplateFilters && nameplateFilters.length &&
            <div>
              <label
                className={classnames({
                  [styles.OffersFiltersLabel]: true
                })}>Nameplate</label>
              <CheckBoxGroup
                styleName="compact"
                items={nameplateFilters.map(filter => ({
                  name: filter.props.name,
                  value: filter.props.value,
                  checked: filter.props.checked
                }))}
                {...fromLinkInputs(this, "nameplate")} />
            </div>
          }
          {
            priceFilter &&
            <div>
              <label
                className={classnames({
                  [styles.OffersFiltersLabel]: true
                })}>{priceFilter.title || "Price Range (AU$)"}</label>
              <InputRange
                min={priceFilter.minValue}
                max={priceFilter.maxValue}
                step={priceFilter.increment}
                {...fromLinkInputs(this, "price")} />
            </div>
          }
          {/* Hiding it for now as per SM-5673 */}
          {/* {
            transmissionFilter &&
            transmissionFilter.options &&
            transmissionFilter.options.length &&
            <div>
              <label
                className={classnames({
                  [styles.OffersFiltersLabel]: true
                })}>{transmissionFilter.title || "Transmission"}</label>
              <CheckBoxGroup
                styleName="compact"
                items={transmissionFilter.options}
                {...fromLinkInputs(this, "transmission")} />
            </div>
          }
          {
            drivetrainFilters && drivetrainFilters.length &&
            <div>
              <label
                className={classnames({
                  [styles.OffersFiltersLabel]: true
                })}>Drive</label>
              <CheckBoxGroup
                styleName="compact"
                items={drivetrainFilters.map(filter => ({
                  name: filter.props.name,
                  value: filter.props.value,
                  checked: filter.props.checked
                }))}
                {...fromLinkInputs(this, "drivetrain")} />
            </div>
          } */}
          <div
            className={classnames({
              [styles.OffersFiltersTabletUpdate]: true
            })}>
            <Button
                styleName="blackOutlined"
                fullWidth
                onClick={onClose}
              >
                Update Search
              </Button>
          </div>
      </div>
    )
  }
}


export default OffersFilters



// WEBPACK FOOTER //
// ./src/AtomicContainers/OffersFilters/OffersFilters.jsx